import { useCallback, useMemo, useState } from 'react';
import { listTaskTypeDescriptors, TaskTypeDescriptor } from '../../../../taskTypes/descriptor';
import { filterTaskTypes, sortTaskTypes } from './filter';

export interface TaskTypesToolViewModel {
  busy: boolean;
  modules: TaskTypeDescriptor[];
  /** Alphabetical subset of `modules` that passes the current display-name query. */
  filteredModules: TaskTypeDescriptor[];
  query: string;
  setQuery: (q: string) => void;
  initialize: () => void;
}

export function useTaskTypesToolViewModel(): TaskTypesToolViewModel {
  const [busy, setBusy] = useState<boolean>(true);
  const [modules, setModules] = useState<TaskTypeDescriptor[]>([]);
  const [query, setQuery] = useState<string>('');

  const initialize = useCallback(() => {
    setBusy(true);
    setModules(sortTaskTypes(listTaskTypeDescriptors()));
    setBusy(false);
  }, []);

  const filteredModules = useMemo(() => filterTaskTypes(modules, query), [modules, query]);

  return { busy, modules, filteredModules, query, setQuery, initialize };
}
